import { types } from "mobx-state-tree";
import { currentUserService } from "../user/CurrentUserStorage";
import dateService from "../date-service/DateService";
import { OrganizationVideoAnalysisCallsUsageResponse } from "../../api-models/response/organization/OrganizationVideoAnalysisCallsUsageResponse";

export const RunVideoAnalysisServiceModel = types
  .model({
    isDoNotShowVACallsExceededWarningMessageAgainSelected: false,
    DO_NOT_SHOW_VA_CALLS_EXCEEDED_WARNING_MESSAGE_LOCAL_STORAGE_KEY: "",
    VA_CALLS_EXCEEDED_WARNING_MESSAGE_DISMISSAL_DATE_LOCAL_STORAGE_KEY: "",
  })
  .actions((self) => {
    return {
      afterCreate() {
        self.DO_NOT_SHOW_VA_CALLS_EXCEEDED_WARNING_MESSAGE_LOCAL_STORAGE_KEY = `shouldNotShowVACallsExceededWarningMessageForOrganization-${currentUserService.currentUser.currentOrganization.id}`;
        self.VA_CALLS_EXCEEDED_WARNING_MESSAGE_DISMISSAL_DATE_LOCAL_STORAGE_KEY = `VACallsExceededWarningMessageForOrganization-${currentUserService.currentUser.currentOrganization.id}-WasDismissedAtDate`;
      },
      setIsDoNotShowVACallsExceededWarningMessageAgainSelected(
        isDoNotShowVACallsExceededWarningMessageAgainSelected: boolean
      ) {
        self.isDoNotShowVACallsExceededWarningMessageAgainSelected =
          isDoNotShowVACallsExceededWarningMessageAgainSelected;
      },
      VACallsStillAvailableAndPopupWasPreviouslyDismissed(
        videoCallsUsage: OrganizationVideoAnalysisCallsUsageResponse,
        requestedCalls: number = 1
      ) {
        return (
          videoCallsUsage.successfulVideoAnalysisCallsCount + requestedCalls <=
            videoCallsUsage.totalVideoAnalysisCallsAvailable &&
          localStorage.getItem(
            self.DO_NOT_SHOW_VA_CALLS_EXCEEDED_WARNING_MESSAGE_LOCAL_STORAGE_KEY
          ) !== null &&
          !dateService.dateIsInInterval(
            localStorage.getItem(
              self.VA_CALLS_EXCEEDED_WARNING_MESSAGE_DISMISSAL_DATE_LOCAL_STORAGE_KEY
            )!,
            videoCallsUsage.billingCycleStartDate!,
            videoCallsUsage.billingCycleEndDate!
          )
        );
      },
      VACallsStillAvailableAndPopupWasNotDismissed(
        videoCallsUsage: OrganizationVideoAnalysisCallsUsageResponse,
        requestedCalls: number = 1
      ) {
        return (
          videoCallsUsage.successfulVideoAnalysisCallsCount + requestedCalls <=
            videoCallsUsage.totalVideoAnalysisCallsAvailable &&
          localStorage.getItem(
            self.DO_NOT_SHOW_VA_CALLS_EXCEEDED_WARNING_MESSAGE_LOCAL_STORAGE_KEY
          ) === null
        );
      },
      VACallsNotAvailableAndPopupWasNotDismissed(
        videoCallsUsage: OrganizationVideoAnalysisCallsUsageResponse,
        requestedCalls: number = 1
      ) {
        return (
          videoCallsUsage.successfulVideoAnalysisCallsCount + requestedCalls >
            videoCallsUsage.totalVideoAnalysisCallsAvailable &&
          localStorage.getItem(
            self.DO_NOT_SHOW_VA_CALLS_EXCEEDED_WARNING_MESSAGE_LOCAL_STORAGE_KEY
          ) === null
        );
      },
      VACallsNotAvailableAndPopupWasDismissedInThisBillingCycle(
        videoCallsUsage: OrganizationVideoAnalysisCallsUsageResponse,
        requestedCalls: number = 1
      ) {
        return (
          videoCallsUsage.successfulVideoAnalysisCallsCount + requestedCalls >
            videoCallsUsage.totalVideoAnalysisCallsAvailable &&
          localStorage.getItem(
            self.DO_NOT_SHOW_VA_CALLS_EXCEEDED_WARNING_MESSAGE_LOCAL_STORAGE_KEY
          ) !== null &&
          dateService.dateIsInInterval(
            localStorage.getItem(
              self.VA_CALLS_EXCEEDED_WARNING_MESSAGE_DISMISSAL_DATE_LOCAL_STORAGE_KEY
            )!,
            videoCallsUsage.billingCycleStartDate!,
            videoCallsUsage.billingCycleEndDate!
          )
        );
      },
      VACallsNotAvailableAndPopupWasDismissedInPreviousBillingCycle(
        videoCallsUsage: OrganizationVideoAnalysisCallsUsageResponse,
        requestedCalls: number = 1
      ) {
        return (
          videoCallsUsage.successfulVideoAnalysisCallsCount + requestedCalls >
            videoCallsUsage.totalVideoAnalysisCallsAvailable &&
          localStorage.getItem(
            self.DO_NOT_SHOW_VA_CALLS_EXCEEDED_WARNING_MESSAGE_LOCAL_STORAGE_KEY
          ) !== null &&
          !dateService.dateIsInInterval(
            localStorage.getItem(
              self.VA_CALLS_EXCEEDED_WARNING_MESSAGE_DISMISSAL_DATE_LOCAL_STORAGE_KEY
            )!,
            videoCallsUsage.billingCycleStartDate!,
            videoCallsUsage.billingCycleEndDate!
          )
        );
      },
      clearVACallsPreferencesFromStorage() {
        localStorage.removeItem(
          self.DO_NOT_SHOW_VA_CALLS_EXCEEDED_WARNING_MESSAGE_LOCAL_STORAGE_KEY
        );
        localStorage.removeItem(
          self.VA_CALLS_EXCEEDED_WARNING_MESSAGE_DISMISSAL_DATE_LOCAL_STORAGE_KEY
        );
      },
      disableVACallsExceededWarningMessageForOrganization() {
        localStorage.setItem(
          self.DO_NOT_SHOW_VA_CALLS_EXCEEDED_WARNING_MESSAGE_LOCAL_STORAGE_KEY,
          "true"
        );
        localStorage.setItem(
          self.VA_CALLS_EXCEEDED_WARNING_MESSAGE_DISMISSAL_DATE_LOCAL_STORAGE_KEY,
          `${new Date()}`
        );
      },
      toggleIsDoNotShowThisPopupAgainSelected() {
        self.isDoNotShowVACallsExceededWarningMessageAgainSelected =
          !self.isDoNotShowVACallsExceededWarningMessageAgainSelected;
      },
    };
  })
  .views((self) => {
    return {
      get isDoNotShowCallsExceededWarningMessageAgainSelected() {
        return self.isDoNotShowVACallsExceededWarningMessageAgainSelected;
      },
    };
  });
